import { ReactNode } from 'react';
import { Icon, Link } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';
import messages from '../fundingRequirementsView/FundingRequirementsView.messages';
import { Dispatch } from 'redux';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { connect } from 'react-redux';
import { getCurrentLocation } from '@iwRouter/HistoryProvider';
import { getQueryParameter } from '@iwRouter/LocationHelper';
import { buildLocationWithSearch } from '../../drawDown/DrawDownHelper';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    goBack: ({
        returnPath,
        drawdownAmount,
        offerId,
        sweep
    }: {
        returnPath: string | undefined;
        drawdownAmount: string | undefined;
        offerId: string | undefined;
        sweep: string | undefined;
    }) => {
        if (returnPath) {
            dispatch({
                type: REQUEST_CHANGE_ROUTER,
                //@ts-ignore
                location: buildLocationWithSearch({
                    pathname: returnPath,
                    offerId,
                    amount: drawdownAmount,
                    sweep
                })
            });
        } else {
            dispatch({
                type: REQUEST_CHANGE_ROUTER,
                location: { pathname: '/' }
            });
        }
    }
});

const FundingHeader = ({
    header,
    subHeader,
    returnPath,
    goBack
}: {
    header: ReactNode;
    subHeader: ReactNode;
    returnPath?: string;
} & ReturnType<typeof mapDispatchToProps>) => {
    const location = getCurrentLocation();

    const drawdownAmount = getQueryParameter(location, 'amount');
    const sweep = getQueryParameter(location, 'sweep');

    const offerId: string | undefined = getQueryParameter(location, 'offerId');

    return (
        <div className="pb-m lg:m-auto lg:max-w-[70%] lg:pb-xl">
            <div className="p-m lg:px-4xl lg:pb-2xl lg:pt-5xl">
                <div className="text-center font-bold md:text-2xl lg:my-l lg:flex-row">
                    {header}
                </div>
                <div className="text-center text-s font-reg lg:text-m">
                    {subHeader}
                </div>
            </div>

            <Link
                className="ml-m lg:ml-5xl"
                onClick={() =>
                    goBack({
                        returnPath,
                        drawdownAmount,
                        offerId,
                        sweep
                    })
                }
            >
                <Icon icon="angleLeft" />
                <FormattedMessage {...messages.backButton} />
            </Link>
        </div>
    );
};
// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(FundingHeader);
